import React, { useEffect, useState } from 'react';
import { Collapse, Dropdown } from 'react-bootstrap';
import { Card } from 'react-bootstrap';
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { logoApplication } from '../../utils/dataApi/dataFormApi';
import { getAndCheckLocalStorage } from '../../utils/storage/localvalueFuction';
import { localStorageData } from '../../utils/storage/localvalue';
import { fetchExchangeRateGetCurency } from '../../actions/request/ExchangeRateRequest';

const ExpenseReport = ({ expenses }) => {



    const [euroToDinar, setEuroToDinar] = useState(0);


    useEffect(() => {
        setEuroToDinar(getAndCheckLocalStorage(localStorageData.ExchangeRateGetNow) || 0)
        async function getExchangeRate() {
            const { buyRate } = await fetchExchangeRateGetCurency("EUR");
            setEuroToDinar(buyRate);
        }
        getExchangeRate();
    }, [expenses])

    // Taux de conversion fictifs
    const conversionRates = {
        DinarToEuro: 1 / euroToDinar, // Calculé comme 0.00391
        DinarToDollar: 1 / 244, // Exemple : si 1 Dollar = 300 Dinars
    };

    // Fonction pour convertir les montants
    const convertCurrency = (amount, rate) => (amount * rate).toFixed(2);



    // État pour gérer les collapsibles
    const [openSections, setOpenSections] = useState({});

    // Fonction pour basculer l'état d'un collapsible
    const toggleCollapse = (key) => {
        setOpenSections((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    // Préparation des données regroupées
    const groupedExpenses = expenses.reduce((acc, expense) => {
        // Déterminer si la dépense est liée à un véhicule ou une propriété
        const patrimoine = expense.vehicle?.brand || expense.vehicle?.model || expense.property?.name || "Autres";

        // Déterminer la grande catégorie de dépense
        const categoryExpenseBig = expense.category?.categoryexpensebig?.name ||
            expense.insurance?.type?.categoryexpensebig?.name ||
            expense.damage?.type?.categoryexpensebig?.name ||
            expense.maintenance?.category?.categoryexpensebig?.name ||
            "Autres";

        // Déterminer la sous-catégorie de dépense
        const subCategory = expense.category?.name ||
            expense.insurance?.type?.name ||
            expense.damage?.type?.name ||
            expense.maintenance?.category?.name ||
            "Autres";

        // Ajouter la dépense au groupe correspondant
        if (!acc[patrimoine]) {
            acc[patrimoine] = {};
        }
        if (!acc[patrimoine][categoryExpenseBig]) {
            acc[patrimoine][categoryExpenseBig] = {
                totalAmount: 0,
                subCategories: {},
            };
        }

        // Ajouter la sous-catégorie
        if (!acc[patrimoine][categoryExpenseBig].subCategories[subCategory]) {
            acc[patrimoine][categoryExpenseBig].subCategories[subCategory] = {
                totalAmount: 0,
            };
        }

        // Mettre à jour les montants
        acc[patrimoine][categoryExpenseBig].totalAmount += expense.amount || 0;
        acc[patrimoine][categoryExpenseBig].subCategories[subCategory].totalAmount += expense.amount || 0;

        return acc;
    }, {});



    // Fonction pour exporter en PDF
    const exportToPDFExpense = () => {
        const doc = new jsPDF({
            orientation: 'portrait', // Orientation du PDF (portrait ou paysage)
            unit: 'pt',             // Unité de mesure (points, mm, etc.)
            format: 'a4'            // Format du papier
        });

        // Ajouter le logo de l'application (optionnel)
        const imgWidth = 40;
        const imgHeight = 15;
        doc.addImage(logoApplication, 'PNG', 10, 10, imgWidth, imgHeight);

        // Titre centré
        doc.setFontSize(16);
        doc.text("Rapport des Dépenses", doc.internal.pageSize.width / 2, 30, { align: 'center' });

        let yOffset = 50; // Position verticale initiale

        // Itérer sur chaque propriété/véhicule
        Object.entries(groupedExpenses).forEach(([patrimoine, categories]) => {
            // Ajouter le titre du patrimoine
            doc.setFontSize(14);
            doc.text(patrimoine, 20, yOffset);
            yOffset += 20;

            // Itérer sur chaque grande catégorie
            Object.entries(categories).forEach(([categoryExpenseBig, data]) => {
                doc.setFontSize(12);
                doc.text(`${categoryExpenseBig} - Total : ${data.totalAmount.toFixed(2)} DZD = ${convertCurrency(data.totalAmount||0 , conversionRates.DinarToEuro)} EURO  `, 30, yOffset);
                yOffset += 15;

                // Créer un tableau pour les sous-catégories
                const rows = Object.entries(data.subCategories).map(([subCategory, subData]) => [
                    subCategory,
                    `${subData.totalAmount.toFixed(2)} DZD`,
                    `${convertCurrency(data.totalAmount||0 , conversionRates.DinarToEuro)} EURO`
                ]);

                // Ajouter le tableau au PDF
                doc.autoTable({
                    head: [["Sous-Catégorie", "Montant (DZD)","Montant (EURO)"]],
                    body: rows,
                    startY: yOffset,
                    theme: "grid",
                    styles: { fontSize: 10 },
                    margin: { left: 30 }
                });

                // Mettre à jour la position verticale après le tableau
                yOffset = doc.lastAutoTable.finalY + 10;
            });

            // Ajouter un espace entre les sections
            yOffset += 10;
        });

        // Pied de page
        doc.setFontSize(10);
        doc.text("Merci pour votre confiance.", 10, doc.internal.pageSize.height - 20);
        doc.setTextColor(46, 128, 2);
        doc.textWithLink("Visitez notre site : www.rezaplus.com", 10, doc.internal.pageSize.height - 10, {
            url: "https://www.rezaplus.com"
        });

        // Télécharger le fichier PDF
        doc.save("Rapport_des_depenses.pdf");
    };



    // Fonction pour exporter en Excel
    const exportToExcelExpense = () => {
        const rows = [];

        // Itérer sur chaque propriété/véhicule
        Object.entries(groupedExpenses).forEach(([patrimoine, categories]) => {
            // Ajouter le titre du patrimoine
            rows.push({ "Patrimoine": patrimoine });

            // Itérer sur chaque grande catégorie
            Object.entries(categories).forEach(([categoryExpenseBig, data]) => {
                rows.push({
                    "Grande Catégorie": categoryExpenseBig,
                    "Total Grande Catégorie (DZD)": `${data.totalAmount.toFixed(2)} DZD`,
                    "Total Grande Catégorie (EURO)": `${convertCurrency(data.totalAmount||0 , conversionRates.DinarToEuro)} EURO`,
                });

                // Itérer sur chaque sous-catégorie
                Object.entries(data.subCategories).forEach(([subCategory, subData]) => {
                    rows.push({
                        "Sous-Catégorie": subCategory,
                        "Montant Sous-Catégorie (DZD)": `${subData.totalAmount.toFixed(2)} DZD`,
                        "Montant Sous-Catégorie (EURO)": `${convertCurrency(subData.totalAmount|| 0 , conversionRates.DinarToEuro)} €`,
                    });
                });
            });

            // Ajouter une ligne vide pour séparer les sections
            rows.push({});
        });

        // Créer le fichier Excel
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, worksheet, "Dépenses");
        XLSX.writeFile(wb, "Dépenses_rezaplus.xlsx");
    };

    return (
        <Card>
            <Card.Header>

                <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    <h5>Historique par catégories</h5>
                    <Dropdown>
                        <Dropdown.Toggle variant="primary" size="sm" id="dropdown-basic">
                            Exporter
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item as="button" onClick={exportToExcelExpense}>
                                Exporter en Excel
                            </Dropdown.Item>
                            <Dropdown.Item as="button" onClick={exportToPDFExpense}>
                                Exporter en PDF
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

            </Card.Header>
            <Card.Body>
                {/* <Card.Text>
                    <strong>Montant  </strong>{totalExpenses} DZD
                </Card.Text> */}
                <div>
                    {/* Itérer sur chaque propriété/véhicule */}
                    {Object.entries(groupedExpenses).map(([patrimoine, categories], indexPatrimoine) => (
                        <Card key={indexPatrimoine} className="mb-3">
                            <Card.Header style={{ cursor: "pointer" }} onClick={() => toggleCollapse(`patrimoine-${indexPatrimoine}`)}>
                                <h5>{patrimoine} ▼</h5>
                            </Card.Header>

                            {/* Contenu collapsible pour ce patrimoine */}
                            <Collapse in={openSections[`patrimoine-${indexPatrimoine}`]}>
                                <Card.Body>
                                    {/* Itérer sur chaque grande catégorie */}
                                    {Object.entries(categories).map(([categoryExpenseBig, data], indexCategory) => (
                                        <Card key={indexCategory} className="mb-3">
                                            <Card.Header style={{ cursor: "pointer" }} onClick={() => toggleCollapse(`category-${indexPatrimoine}-${indexCategory}`)}>
                                                <h6>{categoryExpenseBig} - Total : {data.totalAmount.toFixed(2)} DZD =  {convertCurrency(data.totalAmount || 0, conversionRates.DinarToEuro)} € ▼</h6>
                                            </Card.Header>

                                            {/* Contenu collapsible pour cette grande catégorie */}
                                            <Collapse in={openSections[`category-${indexPatrimoine}-${indexCategory}`]}>
                                                <Card.Body>
                                                    {/* Tableau pour les sous-catégories */}
                                                    <table className="table table-striped table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>Sous-Catégorie</th>
                                                                <th>Montant Total (DZD)</th>
                                                                <th>Montant Total (€)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Object.entries(data.subCategories).map(([subCategory, subData], indexSubCategory) => (
                                                                <tr key={indexSubCategory}>
                                                                    <td>{subCategory}</td>
                                                                    <td>{subData.totalAmount.toFixed(2)} DZD</td>
                                                                    <td>{convertCurrency(subData.totalAmount || 0, conversionRates.DinarToEuro)} € </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </Card.Body>
                                            </Collapse>
                                        </Card>
                                    ))}
                                </Card.Body>
                            </Collapse>
                        </Card>
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};

export default ExpenseReport;